export * from './pauta.service';
import { PautaService } from './pauta.service';
export * from './seguimiento.service';
import { SeguimientoService } from './seguimiento.service';
export const APIS = [PautaService, SeguimientoService];
